import { Pagination, PaginationParametersRequest } from '@shared/model/common';
import { UserProfileOptionListItem, UserProfileOptionType } from '@shared/model/user-profile-option';

export enum UserProfileOptionsDataOrder {
    Name = 'name',
    Type = 'type',
}

export enum UserProfileOptionsDataSort {
    Asc = 'asc',
    Desc = 'desc',
}

/* UserProfileOption list */
export interface UserProfileOptionsDataResponse extends Pagination {
    search: string | null;
    active: boolean | null;
    type: UserProfileOptionType | null;
    code: string | null;
    items: UserProfileOptionListItem[];
    order: UserProfileOptionsDataOrder | null;
    sort: UserProfileOptionsDataSort | null;
}
export interface UserProfileOptionDataRequest extends PaginationParametersRequest {
    search?: string | null;
    active?: boolean;
    code?: string;
    type?: UserProfileOptionType;
    order?: UserProfileOptionsDataOrder;
    sort?: UserProfileOptionsDataSort;
}

/* UserProfileOption list public */
export interface UserProfileOptionPublicDataResponse extends Pagination {
    search: string | null;
    code: string | null;
    type: UserProfileOptionType | null;
    items: UserProfileOptionListItem[];
    active: boolean | null;
    order: UserProfileOptionsDataOrder | null;
    sort: UserProfileOptionsDataSort | null;
}
export interface UserProfileOptionPublicDataRequest extends PaginationParametersRequest {
    search?: string | null;
    code?: string;
    type?: UserProfileOptionType;
    order?: UserProfileOptionsDataOrder;
    sort?: UserProfileOptionsDataSort;
}
